// Guards against double-execution when product-card.liquid is rendered multiple times
if (!window.__pcDelivery) {
  window.__pcDelivery = true;

  (function () {
    const STORAGE_KEY = 'de_city';
    let refreshTimer = null;

    function currentCity() {
      return localStorage.getItem(STORAGE_KEY) || 'Dubai';
    }

    function updateCards(city, cards) {
      const targets = cards || document.querySelectorAll('.product-card-delivery-estimator');
      if (!targets.length) return;
      const dateStr = window.AEDeliveryDate.format(window.AEDeliveryDate.compute(), false);
      targets.forEach((card) => {
        const cityEl = card.querySelector('.product-card-delivery-city');
        const dateEl = card.querySelector('.product-card-delivery-date');
        if (cityEl && cityEl.textContent !== city) cityEl.textContent = city;
        if (dateEl && dateEl.textContent !== dateStr) dateEl.textContent = dateStr;
      });
    }

    function scheduleRefresh() {
      clearTimeout(refreshTimer);
      const { nextUpdateMs } = window.AEDeliveryDate.compute();
      const delay = Math.max(nextUpdateMs - Date.now() + 50, 50);
      refreshTimer = setTimeout(() => {
        updateCards(currentCity());
        scheduleRefresh();
      }, delay);
    }

    // Collection grids (infinite scroll / "load more") insert new product cards via
    // insertAdjacentHTML, which never executes their embedded <script> tag, so those
    // cards would otherwise never get their delivery date filled in. Watch for them.
    function observeNewCards() {
      const observer = new MutationObserver((mutations) => {
        const newCards = [];
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('.product-card-delivery-estimator')) {
              newCards.push(node);
            }
            if (node.querySelectorAll) {
              node.querySelectorAll('.product-card-delivery-estimator').forEach((element) => newCards.push(element));
            }
          });
        });
        if (newCards.length) updateCards(currentCity(), newCards);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    function init() {
      updateCards(currentCity());
      observeNewCards();
      scheduleRefresh();
    }

    // Re-render all cards when PDP estimator city changes
    window.addEventListener('delivery-city-changed', (event) => {
      if (event.detail && event.detail.city) updateCards(event.detail.city);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') return;
      updateCards(currentCity());
      scheduleRefresh();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
}
